exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttonsSearch-enter-active[data-v-05c116de],.buttonsSearch-leave-active[data-v-05c116de]{transition:all 1s}.buttonsSearch-enter[data-v-05c116de],.buttonsSearch-leave-to[data-v-05c116de]{opacity:0}.search-on-click-btn[data-v-05c116de]{right:0;top:0;font-size:16px;border-left:1px solid #000}.remove-search[data-v-05c116de]{right:90px;top:0;font-size:20px}", ""]);

// exports
